class ToyzaarHeader {
  constructor() {
    this.cache();

    if (!this.header) return;

    this.activeMegaPanel = null;
    this.closeTimeout = null;
    this.announcementSwiper = null;
    this.searchObserver = null;

    this.bindEvents();
    this.init();
  }

  cache() {
    this.body = document.body;
    this.header = document.querySelector(".tz-header");
    this.overlay = document.querySelector(".tz-header__overlay");
    this.searchModal = document.querySelector(".tz-header__search-modal");
    this.searchDialog = document.querySelector(".tz-header__search-dialog");
    this.drawer = document.querySelector(".tz-header__drawer");
    this.drawerToggles = [];
    this.menuButton = document.querySelector(".tz-header__menu");
    this.searchButton = document.querySelector(".tz-header__search");
    this.searchClose = document.querySelector(".tz-header__search-close");
    this.drawerClose = document.querySelector(".tz-header__drawer-close");
    this.navItems = Array.from(document.querySelectorAll(".tz-header__nav-item.has-children"));
    this.megaMenu = document.querySelector(".tz-header__mega");
    this.megaPanels = Array.from(document.querySelectorAll(".tz-header__mega-panel"));
    this.searchInput = document.querySelector(".search__input");
    this.popularSearches = document.querySelector(".tz-header__popular");
    this.results = document.querySelector(".tz-header__results");
    this.announcementSlider = document.querySelector(".tz-header__announcement-slider");
    this.predictiveSearch = document.querySelector("predictive-search");
  }

  bindEvents() {
    window.addEventListener("scroll", () => this.stickyHeader(), { passive: true });

    this.searchButton?.addEventListener("click", () => this.openSearch());
    this.searchClose?.addEventListener("click", () => this.closeSearch());
    this.menuButton?.addEventListener("click", () => this.toggleDrawer());
    this.drawerClose?.addEventListener("click", () => this.closeDrawer());
    this.overlay?.addEventListener("click", () => this.closeAll());

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.closeAll();
      }
    });

    this.searchInput?.addEventListener("input", () => this.handleSearchInput());
    this.bindMegaMenu();
    this.bindMobileMenu();
  }

  init() {
    this.stickyHeader();
    this.initAnnouncement();
    this.initSearchObserver();
    this.handleSearchInput();
  }

  stickyHeader() {
    if (!this.header) return;

    this.header.classList.toggle("is-scrolled", window.scrollY > 30);


    // if (!this.megaMenu.classList.contains("is-active")) return;

    this.megaMenu.classList.toggle("is-scrolled", window.scrollY > 30);
  }

  bindMegaMenu() {
    if (!this.navItems.length || !this.megaMenu) return;

    const queueClose = () => {
      window.clearTimeout(this.closeTimeout);
      this.closeTimeout = window.setTimeout(() => {
        this.closeMegaMenu();
      }, 150);
    };

    const clearClose = () => {
      window.clearTimeout(this.closeTimeout);
    };

    this.navItems.forEach((item) => {
      item.addEventListener("mouseenter", () => {
        clearClose();
        this.openMegaMenu(item.dataset.menu);
      });

      item.addEventListener("mouseleave", queueClose);
      item.addEventListener("focusin", () => {
        clearClose();
        this.openMegaMenu(item.dataset.menu);
      });
    });

    this.megaMenu.addEventListener("mouseenter", clearClose);
    this.megaMenu.addEventListener("mouseleave", queueClose);
  }

  openMegaMenu(panelKey) {
    if (!this.megaMenu) return;

    this.activeMegaPanel = panelKey;
    this.megaMenu.classList.add("is-active");
    this.megaMenu.setAttribute("aria-hidden", "false");

    this.navItems.forEach((item) => {
      const isActive = item.dataset.menu === panelKey;
      item.classList.toggle("is-active", isActive);
    });

    this.megaPanels.forEach((panel) => {
      panel.classList.toggle("is-active", panel.dataset.panel === panelKey);
    });
  }

  closeMegaMenu() {
    if (!this.megaMenu) return;

    this.activeMegaPanel = null;
    this.megaMenu.classList.remove("is-active");
    this.megaMenu.setAttribute("aria-hidden", "true");

    this.navItems.forEach((item) => {
      item.classList.remove("is-active");
    });

    this.megaPanels.forEach((panel) => {
      panel.classList.remove("is-active");
    });
  }

  bindMobileMenu() {
  if (!this.drawer) return;

  this.drawerToggles = Array.from(
    this.drawer.querySelectorAll(".tz-header__drawer-toggle")
  );

  if (!this.drawerToggles.length) return;

  this.drawerToggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      const submenuId = toggle.getAttribute("aria-controls");
      const submenu = document.getElementById(submenuId);

      if (!submenu) return;

      const isOpen =
        toggle.getAttribute("aria-expanded") === "true";

      // Close all other open submenus
      this.drawerToggles.forEach((otherToggle) => {
        if (otherToggle === toggle) return;

        const otherId = otherToggle.getAttribute("aria-controls");
        const otherSubmenu = document.getElementById(otherId);

        otherToggle.setAttribute("aria-expanded", "false");

        if (otherSubmenu) {
          otherSubmenu.hidden = true;
        }
      });

      // Toggle current submenu
      toggle.setAttribute(
        "aria-expanded",
        String(!isOpen)
      );

      submenu.hidden = isOpen;
    });
  });
}

  openSearch() {
    if (!this.searchModal) return;

    this.closeDrawer({ keepOverlay: true });
    this.searchModal.classList.add("is-active");
    this.searchModal.setAttribute("aria-hidden", "false");
    this.searchButton?.setAttribute("aria-expanded", "true");
    this.updateOverlay();

    window.requestAnimationFrame(() => {
      this.searchInput?.focus();
    });
  }

  closeSearch(options = {}) {
    if (!this.searchModal) return;

    this.searchModal.classList.remove("is-active");
    this.searchModal.setAttribute("aria-hidden", "true");
    this.searchButton?.setAttribute("aria-expanded", "false");

    if (!options.keepOverlay) {
      this.updateOverlay();
    }
  }

  toggleDrawer() {
    if (this.drawer?.classList.contains("is-active")) {
      this.closeDrawer();
      return;
    }

    this.openDrawer();
  }

  openDrawer() {
    if (!this.drawer) return;

    this.closeSearch({ keepOverlay: true });
    this.closeMegaMenu();

    this.drawer.classList.add("is-active");
    this.drawer.setAttribute("aria-hidden", "false");
    this.menuButton?.classList.add("is-active");
    this.menuButton?.setAttribute("aria-expanded", "true");
    this.updateOverlay();
  }

  closeDrawer(options = {}) {
  if (!this.drawer) return;

  this.drawer.classList.remove("is-active");
  this.drawer.setAttribute("aria-hidden", "true");
  this.menuButton?.classList.remove("is-active");
  this.menuButton?.setAttribute("aria-expanded", "false");

  // Reset mobile submenus
  this.drawerToggles?.forEach((toggle) => {
    const submenuId = toggle.getAttribute("aria-controls");
    const submenu = document.getElementById(submenuId);

    toggle.setAttribute("aria-expanded", "false");

    if (submenu) {
      submenu.hidden = true;
    }
  });

  if (!options.keepOverlay) {
    this.updateOverlay();
  }
}

  updateOverlay() {
    const searchActive = this.searchModal?.classList.contains("is-active");
    const drawerActive = this.drawer?.classList.contains("is-active");
    const overlayActive = Boolean(searchActive || drawerActive);

    this.overlay?.classList.toggle("is-active", overlayActive);
    this.body.classList.toggle("tz-lock", overlayActive);
  }

  closeAll() {
    this.closeSearch({ keepOverlay: true });
    this.closeDrawer({ keepOverlay: true });
    this.closeMegaMenu();
    this.overlay?.classList.remove("is-active");
    this.body.classList.remove("tz-lock");

    if (this.searchInput) {
      this.searchInput.value = "";
      this.searchInput.dispatchEvent(new Event("input", { bubbles: true }));
    }

    this.handleSearchInput();
  }

  handleSearchInput() {
    if (!this.searchInput || !this.popularSearches) return;

    const hasValue = this.searchInput.value.trim().length > 1;
    this.popularSearches.classList.toggle("tz-hidden", hasValue);
  }

  initAnnouncement() {
    if (!this.announcementSlider || typeof window.Swiper === "undefined") return;

    if (this.announcementSwiper && typeof this.announcementSwiper.destroy === "function") {
      this.announcementSwiper.destroy(true, true);
    }

    this.announcementSwiper = new window.Swiper(this.announcementSlider, {
      loop: true,
      effect: "fade",
      autoplay: {
        delay: 3500,
        disableOnInteraction: false
      },
      allowTouchMove: false
    });
  }

  initSearchObserver() {
    if (!this.results || typeof MutationObserver === "undefined") return;

    this.searchObserver = new MutationObserver(() => {
      const hasContent = this.results.innerHTML.trim().length > 0;
      this.results.classList.toggle("is-loaded", hasContent);
    });

    this.searchObserver.observe(this.results, {
      childList: true,
      subtree: true
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new ToyzaarHeader();
});
